
import React from 'react';

const ReturnsPage: React.FC = () => {
  return (
    <div className="container mx-auto px-4 md:px-6 py-20">
      <div className="max-w-3xl mx-auto space-y-12">
        <h1 className="text-4xl font-serif font-bold text-stone-900">İptal & İade Koşulları</h1>
        <div className="prose prose-stone text-stone-600 space-y-8 font-medium">
          <section className="space-y-4">
            <h3 className="text-xl font-bold text-stone-900">İade Şartları</h3>
            <p>Ürünü teslim aldıktan sonra 14 gün içerisinde, kutusu açılmamış ve zarar görmemiş olması kaydıyla iade edebilirsiniz.</p>
          </section>
          <section className="space-y-4">
            <h3 className="text-xl font-bold text-stone-900">Hasarlı Ürünler</h3>
            <p>Kargo sırasında hasar gören ürünler için kargo görevlisine tutanak tutturmanız veya paketi açarken video kaydı almanız önerilir. Hasarlı ürünler ücretsiz olarak yenisiyle değiştirilir.</p>
          </section>
          <section className="space-y-4">
            <h3 className="text-xl font-bold text-stone-900">İade Süreci</h3>
            <p>İade talebinizi "Hesabım" sayfasındaki destek talebi üzerinden veya hello@luminahome.com adresinden bize iletebilirsiniz.</p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default ReturnsPage;
